import React from 'react';
import { Card } from 'react-bootstrap';

import DeduccOSalidasResumen from './fideicomisonoempresarial/DeduccOSalidasResumen';
import IngresosOEntradasResumen from './fideicomisonoempresarial/IngresosOEntradasResumen';
import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';
import RetEfectFideicomisoResumen from './fideicomisonoempresarial/RetEfectFideicomisoResumen';

const ComplementoFideicomisoNoEmpresarialResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('Fideicomisonoempresarial');
  };

  const handleOnEdit = () => {
    onEdit('Fideicomisonoempresarial', data);
  };

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          <div className="d-block mt-3 mb-2">Fideicomiso No Empresarial, Versión {data.Version}</div>
        </Card.Subtitle>

        <IngresosOEntradasResumen data={data} />
        <DeduccOSalidasResumen data={data} />
        <RetEfectFideicomisoResumen data={data} />

        <ComplementoSummaryActionButtons
          onEdit={handleOnEdit}
          onDelete={handleOnDelete}
        />
      </Card.Body>
    </Card>
  );
};

export default ComplementoFideicomisoNoEmpresarialResumen;
